import styles from './ImageViewer.module.scss'
import { motion, AnimatePresence } from 'framer-motion'
import Slider from './Slider'
import Image from 'next/image'
import { imgUrl } from '@bww/beke-lib/sanity-client'
import { useEffect } from 'react'

export default function ImageViewer({ visible, close, images = [] }) {
  useEffect(() => {
    const escapeHandler = (e) => {
      if (e.key === 'Escape') close()
    }
    window.addEventListener('keydown', escapeHandler)
    return () => {
      window.removeEventListener('keydown', escapeHandler)
    }
  }, [close])

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={styles.overlay}
          key="modal"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        >
          <button className={styles.closeButton} onClick={close}>
            &times;
          </button>
          <Slider
            slideElements={images.map((image) => (
              <ImageSlide image={image} key={image._key} />
            ))}
          />
        </motion.div>
      )}
    </AnimatePresence>
  )
}

const ImageSlide = ({ image }) => {
  return (
    <div className={styles.imageWrapper}>
      <Image
        src={imgUrl(image).fit('max').width(1920).url()}
        alt={image.alt || ''}
        style={{ objectFit: 'contain' }}
        placeholder={image?.lqip ? 'blur' : undefined}
        blurDataURL={image?.lqip}
        fill
        draggable={false}
      />
    </div>
  )
}
